import { CSSProperties } from "react";

/** A small swatch of a color chosen at runtime.
 *
 * The fill and its darkened border come from a value only known at render time,
 * so they stay inline styles; Tailwind carries the fixed box metrics. `style`
 * is merged rather than ignored so `<Spacing asChild>` can still place it.
 */
export const ColorBox: React.FC<{ color: string; style?: CSSProperties }> = ({
  color,
  style,
}) => (
  <span
    className="inline-block h-[1em] w-[1.3em] border border-solid"
    style={{
      backgroundColor: color,
      borderColor: `color-mix(in hsl, ${color}, black 20%)`,
      ...style,
    }}
  />
);
